import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  data: null,
  balanceData: null,
  selects: null,
  hasSignedDocument: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET:
      return { ...state, isLoading: true };
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        selects: action.payload.selects,
        hasSignedDocument: action.payload.hasSignedDocument,
      };
    case actionTypes.GET_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_FULFILLED:
      return { ...state, isLoading: false, data: action.payload.data };
    case actionTypes.DELETE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_FULFILLED:
      return { ...state, isLoading: false, data: action.payload.data };
    case actionTypes.CREATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.MODIFY:
      return { ...state, isLoading: true };
    case actionTypes.MODIFY_FULFILLED:
      return { ...state, isLoading: false, data: action.payload.data };
    case actionTypes.MODIFY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DOWNLOAD:
      return { ...state, isLoading: true };
    case actionTypes.DOWNLOAD_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.DOWNLOAD_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPLOAD:
      return { ...state, isLoading: true };
    case actionTypes.UPLOAD_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.UPLOAD_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_BALANCE:
      return { ...state, isLoading: true };
    case actionTypes.GET_BALANCE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        balanceData: action.payload.data,
      };
    case actionTypes.GET_BALANCE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_BALANCE:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_BALANCE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        balanceData: action.payload.data,
      };
    case actionTypes.CREATE_BALANCE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE_BALANCE:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_BALANCE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        balanceData: action.payload.data,
      };
    case actionTypes.DELETE_BALANCE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GENERATE:
      return { ...state, isLoading: true };
    case actionTypes.GENERATE_FULFILLED:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes.GENERATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
